import { defineMessages, useIntl } from '@faceup/localization'
import { setCustomYupValidatorsErrorMessages, yup } from '@faceup/validation'
import { sharedMessages } from '../Shared/translations'

const messages = defineMessages('followUp.hooks.useYupLocalization', [
  {
    id: 'validationStringMin',
    defaultMessage: 'Minimum length is {min} characters',
    values: { min: true },
  },
  {
    id: 'validationStringMax',
    defaultMessage: 'Maximum length is {max} characters',
    values: { max: true },
  },
  {
    id: 'validationArrayMin',
    defaultMessage: 'This field must have at least {min} item.',
    values: { min: true },
  },
  {
    id: 'validationArrayMax',
    defaultMessage: 'This field can have up to {max} items.',
    values: { max: true },
  },
  { id: 'invalidEmail', defaultMessage: 'This email address is invalid.' },
  { id: 'invalidUrl', defaultMessage: 'This URL address is invalid.' },
  { id: 'invalidIpAddress', defaultMessage: 'This IP address is invalid.' },
  { id: 'invalidPhone', defaultMessage: 'This phone number is invalid.' },
  { id: 'invalidFile', defaultMessage: 'This file is invalid.' },
  { id: 'invalidUuid', defaultMessage: 'This UUID is invalid.' },
] as const)

/**
 * Applies the app's localized yup error messages to the global yup locale.
 * Call once high in the tree (inside an IntlProvider). Runs on every render so
 * the locale stays in sync when the language changes.
 */
export const useYupLocalization = () => {
  const { formatMessage } = useIntl()

  yup.setLocale({
    mixed: {
      default: formatMessage(sharedMessages.invalidInputError),
      required: formatMessage(sharedMessages.invalidInputError),
      notOneOf: formatMessage(sharedMessages.invalidInputError),
      oneOf: formatMessage(sharedMessages.invalidInputError),
    },
    string: {
      min: ({ min }) => formatMessage(messages.validationStringMin, { values: { min } }),
      max: ({ max }) => formatMessage(messages.validationStringMax, { values: { max } }),
    },
    array: {
      min: ({ min }) => formatMessage(messages.validationArrayMin, { values: { min } }),
      max: ({ max }) => formatMessage(messages.validationArrayMax, { values: { max } }),
    },
  })

  setCustomYupValidatorsErrorMessages({
    email: formatMessage(messages.invalidEmail),
    url: formatMessage(messages.invalidUrl),
    ipAddress: formatMessage(messages.invalidIpAddress),
    phone: formatMessage(messages.invalidPhone),
    file: formatMessage(messages.invalidFile),
    uuid: formatMessage(messages.invalidUuid),
  })
}
